import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AnnouncementService } from 'src/app/announcement/announcement.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-richtextbox-editor',
  templateUrl: './richtextbox-editor.component.html',
  styleUrls: ['./richtextbox-editor.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RichtextboxEditorComponent),
      multi: true
    }
  ]
})
export class RichtextboxEditorComponent implements OnInit {
  public apiKey: string = environment.tinyMceKey;
  public isloading = true;
  public editorVisible = true;

  public content = '';
  public config: any = {
    menubar: true,

    statusbar: false,
    branding: false,
    height: '300',
    plugins: [
      'advlist autolink lists link image charmap print preview anchor',
      'searchreplace visualblocks code  textcolor',
      'insertdatetime media table paste code  imagetools'
    ],
    default_link_target: '_blank',
    images_upload_handler: this.uploadImage.bind(this),
    onchange_callback: this.contentChanged.bind(this),
    relative_urls: false,
    paste_data_images: true,
    toolbar:
      'undo redo | link image | code | fontselect fontsizeselect formatselect |   bold italic backcolor forecolor | \
       alignleft aligncenter alignright alignjustify | table \
       bullist numlist outdent indent | removeformat ',
    setup: function (editor) {
      const context = this;
      editor.on('init', function (e) {
        context.isloading = false;
      });
    }.bind(this),
    file_picker_callback: function (cb, value, meta) {
      const context = this;
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      input.onchange = function (data) {
        const file = data.currentTarget.files[0];
        context.announcementService.saveAnnouncementImages(file).subscribe(response => {
          if (response && response.docUrl) {
            cb(response.docUrl, { title: file.name });
          }
        });
      }.bind(this);

      input.click();
    }.bind(this)
  };


  propagateChange: any = () => {
  }

  constructor(private announcementService: AnnouncementService) { }

  ngOnInit() {
  }

  contentChanged() {
    this.propagateChange(this.content);
  }
  public uploadImage(blobInfo, success, failure) {
    this.announcementService.saveAnnouncementImages(blobInfo.blob()).subscribe(response => {
      const res: any = response;
      if (res && res.docUrl) {
        success(res.docUrl);
      }
    });

  }


  setDisabledState?(isDisabled: boolean): void {

  }

  writeValue(value: string): void {
    this.content = value;
  }
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
  }
}
